import { BACKEND_URL } from "./backendconfig";
const api = `${BACKEND_URL.replace(/\/+$/, "")}/users.php`;
export async function accountRequest(action, values, signal) {
  const response = await fetch(`${api}?action=${encodeURIComponent(action)}`, {
    method: values === undefined ? "GET" : "POST",
    credentials: "include",
    cache: "no-store",
    signal,
    ...(values === undefined ? {} : {
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values),
    }),
  });
  let data;
  try { data = await response.json(); }
  catch { throw new Error("Invalid server response. Check users.php."); }
  if (!response.ok) {
    const error = new Error(data.message || "Unable to process request.");
    error.status = response.status;
    throw error;
  }
  return data;
}
export function notifyAccountChange() {
  window.dispatchEvent(new Event("ltc-auth-changed"));
}
